export const selectNewConsultState = state => state.newConsult;
export const selectPaymentsState = state => state.payments;
export const selectUserState = state => state.user;
export const selectFeatureMapState = state => state.featureMap;
export const selectProblemAreasState = state => state.problemAreas;
export const selectDoctorProfileState = state => state.doctorProfile;
export const selectConsultUserProfileState = state => state.consultUserProfile;
